import DeleteIcon from "@mui/icons-material/Delete";
import { Grid } from "@mui/material";
import { useFieldArray, useFormContext } from "react-hook-form";
import { BorderedFormGrid } from "../../../../Forms/BorderedFormGrid";
import { SmallAddButton } from "../../../../Layout/Buttons/SmallAddButton";
import { FieldArrayNoContentMessage } from "../../../../Forms/FieldArray/FieldArrayNoContentMessage";
import { StyledIconButton } from "../../../../Layout/Buttons/StyledIconButton";
import { confirm } from "../../../../Layout/Dialog/ConfirmDialog";
import { bidPackObjectName } from "../../../BidPacks/BidPack";
import { RateAgreement } from "../../RateAgreement";
import { defaultRateAgreementBidPack, RateAgreementBidPack } from "../../RateAgreementBidPack";
import { RateAgreementBidPackSubForm } from "./RateAgreementBidPackSubForm";
import { useIsUserInRoles } from "../../../../Auth/useIsUserInRoles";
import { AuthorizationPolicies } from "../../../../Auth/AuthorizationPolicy";

type Props = {
  rateAgreementId: number | null;
};

export const RateAgreementBidPackForm = ({ rateAgreementId }: Props) => {
  const {
    control,
    formState: { disabled: isFormDisabled },
  } = useFormContext<RateAgreement>();
  const { fields, append, remove } = useFieldArray<RateAgreement>({
    control,
    name: "AssignedBidPacks",
  });

  const addToFieldArray = (rateAgreementBidPack: RateAgreementBidPack) =>
    append(rateAgreementBidPack);

  const removeBidPackWithToastFromFieldArray = async (
    index: number,
    objectName: string,
    rateAgreementBidPack: RateAgreementBidPack
  ) => {
    const isConfirmed = await confirm(
      `Do you really want to delete ${objectName} ${rateAgreementBidPack.Name}?`
    );

    if (!isConfirmed) {
      return;
    }

    remove(index);
  };

  const isUserInAdminNetworkRole = useIsUserInRoles(AuthorizationPolicies.RequireAdminNetworkRoles);
  return (
    <>
      <SmallAddButton
        onClick={() => addToFieldArray(defaultRateAgreementBidPack)}
        disabled={!isUserInAdminNetworkRole}
      />

      <BorderedFormGrid>
        {fields.length === 0
          ? FieldArrayNoContentMessage({
              message: "No Bid Packs exist for this Rate Agreement yet.",
            })
          : fields.map((rateAgreementBidPack, index) => {
              return (
                <Grid container item>
                  <Grid item xs={11}>
                    <RateAgreementBidPackSubForm
                      bidPackIndex={index}
                      key={rateAgreementBidPack.id}
                      control={control}
                      rateAgreementId={rateAgreementId}
                    />
                  </Grid>
                  <Grid item container xs={1} justifyContent="flex-end">
                    <StyledIconButton
                      onClick={() =>
                        removeBidPackWithToastFromFieldArray(
                          index,
                          bidPackObjectName,
                          rateAgreementBidPack
                        )
                      }
                      disabled={isFormDisabled}
                    >
                      <DeleteIcon />
                    </StyledIconButton>
                  </Grid>
                </Grid>
              );
            })}
      </BorderedFormGrid>
    </>
  );
};
